import * as React from 'react';
export var Card = function (props) {
    var title = props.title;
    return React.createElement("div", null,
        title,
        " \u6309\u94AEdemo");
};
